<button [disabled]="disabled">
  @if (!svgIcon) {
    <mat-icon>{{ icon }}</mat-icon>
  }
  @if (svgIcon) {
    <mat-icon [svgIcon]="svgIcon"></mat-icon>
  }
</button>
